const checkIfSpotIsMixed = (actionFrequencies) => {
	let nonZeroFrequencyActions = 0;
	Object.keys(actionFrequencies).forEach((action) => {
		if (actionFrequencies[action]) nonZeroFrequencyActions++;
	});
	return nonZeroFrequencyActions > 1 ? true : false;
};

export default checkIfSpotIsMixed;
